export default function disableContrast() {
    document.getElementById('cya11y-filter-style')?.remove();
    document.documentElement.classList.remove('cya11y-root-filter');
    document.body.classList.remove('cya11y-filter', 'cya11y-dark-contrast');
}